import React from 'react'

const Holiday = () => {
  return (
    <div>Holiday</div>
  )
}

export default Holiday